import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    id: null,
    transcript: [],
    pendingResponse: false,
    stateMachine: {
        current: null,
        states: []
    }
};

const chatSlice = createSlice({
    name: "chat",
    initialState,
    reducers: {
        sessionUpdated(state, action) {
            return {
                id: action.payload.id,
                transcript: action.payload.transcript,
                pendingResponse: false,
                stateMachine: {current: state.stateMachine.current, states: [...state.stateMachine.states]}
            }
        },
        messagePosted(state, action) {
            return {
                id: state.id,
                transcript: action.payload.transcript,
                pendingResponse: true,
                stateMachine: {current: state.stateMachine.current, states: [...state.stateMachine.states]}         
            }
        },
        responseReceived(state,action) {
            return {
                id: state.id,
                transcript: action.payload.transcript,
                pendingResponse: false,
                stateMachine: {current: state.stateMachine.current, states: [...state.stateMachine.states]}           
            }
        },
        sessionDeleted(state) {
            return {
                id: null,
                transcript: [],
                pendingResponse: false,
                stateMachine: {current: state.stateMachine.current, states: [...state.stateMachine.states]}
            }
        },
        stateMachineTrigerred(state,action) {
            return {
                id: state.id,
                transcript: state.transcript,
                pendingResponse: false,
                stateMachine: {current: action.payload.next, states: [...state.stateMachine.states, action.payload.next]}
            }
        },
        sessionCleared(state) {
            return {
                id: null,
                transcript: [],
                pendingResponse: false,
                stateMachine: {
                    current: null,
                    states: []
                }
            }
        }
    }
})

export const chatActions = chatSlice.actions;
export default chatSlice
